import classnames from 'classnames'
import * as R from 'ramda'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { userHasChatPlaybooksWrite } from 'utils/access'

import FileSizeTooLargeModal from './FileSizeTooLargeModal'
import PublishButton from './PublishButton'
import SaveStatus from './SaveStatus'

import './style.css'

const StatusBar = ({
  playbook,
  publishedPlaybook,
  isSaving,
  isPreviewState,
  isPlaybookDirty,
  onPostPublish,
  trackPublishAndResetTimer,
  hasFileSizeError,
}) => {
  const { playbook: playbookErrors, experiment: experimentErrors } =
    useSelector(R.pathOr({}, ['__PLAYBOOK_EDITOR', 'playbookValidation']))

  const hasPlaybookErrors = !R.isEmpty({
    ...playbookErrors,
    ...experimentErrors,
  })

  const hasExperiment = !!playbook.experiment
  const isExperimentEnabled = publishedPlaybook.experiment?.enabled

  const shouldHideStatusBar = useMemo(() => {
    if (!userHasChatPlaybooksWrite()) {
      return true
    }
    if (window.location.pathname.includes('form-setup')) {
      return true
    }
    return hasExperiment ? isPreviewState : !isPlaybookDirty || isPreviewState
  }, [hasExperiment, isPlaybookDirty, isPreviewState])

  const statusBarClassName = classnames(
    'playbook-status-bar',
    isExperimentEnabled && 'playbook-status-bar--experiment',
    (hasPlaybookErrors || hasFileSizeError) && 'playbook-status-bar--errors'
  )

  return (
    <>
      {!shouldHideStatusBar && (
        <div className={statusBarClassName}>
          <SaveStatus
            isExperimentEnabled={isExperimentEnabled}
            isPlaybookDirty={isPlaybookDirty}
            hasPlaybookErrors={hasPlaybookErrors}
            hasFileSizeError={hasFileSizeError}
          />
          <PublishButton
            isSaving={isSaving}
            isExperimentEnabled={isExperimentEnabled}
            hasExperiment={hasExperiment}
            isDisabled={hasPlaybookErrors || hasFileSizeError}
            playbook={playbook}
            publishedPlaybook={publishedPlaybook}
            onPostPublish={onPostPublish}
            trackPublishAndResetTimer={trackPublishAndResetTimer}
          />
        </div>
      )}
      <FileSizeTooLargeModal hasFileSizeError={hasFileSizeError} />
    </>
  )
}

export default StatusBar
